var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ALLE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stops_Z\\xE4hler",
    transform: "translate(-5.000000, -3.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 1.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,2.96119092 C2.01214286,2.96119092 0,4.99569092 0,7.51119092 C0,10.9236909 4.5,15.9611909 4.5,15.9611909 C4.5,15.9611909 9,10.9236909 9,7.51119092 C9,4.99569092 6.98785714,2.96119092 4.5,2.96119092 L4.5,2.96119092 Z M4.5,8.96119092 C3.672,8.96119092 3,8.28919092 3,7.46119092 C3,6.63319092 3.672,5.96119092 4.5,5.96119092 C5.328,5.96119092 6,6.63319092 6,7.46119092 C6,8.28919092 5.328,8.96119092 4.5,8.96119092 L4.5,8.96119092 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSmall);
export default __webpack_public_path__ + "static/media/pin_small.2885a5185bffc1c7838d69a52d4d1fa5.svg";
export { ForwardRef as ReactComponent };